// export const MAINAPIURL = "https://gymapi.dsmapps.com/api";
//export const MAINAPIURL = "http://localhost/Backend/api";
export const MAINAPIURL = "https://api.acticswellness.com/api";
export const SYSTEMNAME = "Gym Master";
export const MAINVERSION = "1.7.10";
export const CUSTOMERNAME = "Actics Fitness Studio";
export const APPBACKGROUND_COLOR = "rgb(201, 220, 228)";